export interface CompanyTheme {
  name: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  gradient: string;
  textColor: string;
  accentColor: string;
}

export const companyThemes: CompanyTheme[] = [
  {
    name: "Apple",
    logo: "🍎",
    primaryColor: "#000000",
    secondaryColor: "#f5f5f7",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    textColor: "#ffffff",
    accentColor: "#007aff"
  },
  {
    name: "Google",
    logo: "🔍",
    primaryColor: "#4285f4",
    secondaryColor: "#34a853",
    gradient: "linear-gradient(135deg, #4285f4 0%, #34a853 50%, #fbbc05 75%, #ea4335 100%)",
    textColor: "#ffffff",
    accentColor: "#fbbc05"
  },
  {
    name: "Tesla",
    logo: "⚡",
    primaryColor: "#cc0000",
    secondaryColor: "#000000",
    gradient: "linear-gradient(135deg, #cc0000 0%, #000000 100%)",
    textColor: "#ffffff",
    accentColor: "#cc0000"
  },
  {
    name: "Microsoft",
    logo: "🪟",
    primaryColor: "#0078d4",
    secondaryColor: "#005a9e",
    gradient: "linear-gradient(135deg, #0078d4 0%, #005a9e 100%)",
    textColor: "#ffffff",
    accentColor: "#40e0d0"
  },
  {
    name: "Amazon",
    logo: "📦",
    primaryColor: "#ff9900",
    secondaryColor: "#232f3e",
    gradient: "linear-gradient(135deg, #ff9900 0%, #232f3e 100%)",
    textColor: "#ffffff",
    accentColor: "#ff9900"
  },
  {
    name: "Netflix",
    logo: "🎬",
    primaryColor: "#e50914",
    secondaryColor: "#221f1f",
    gradient: "linear-gradient(135deg, #e50914 0%, #221f1f 100%)",
    textColor: "#ffffff",
    accentColor: "#e50914"
  },
  {
    name: "Spotify",
    logo: "🎵",
    primaryColor: "#1db954",
    secondaryColor: "#191414",
    gradient: "linear-gradient(135deg, #1db954 0%, #191414 100%)",
    textColor: "#ffffff",
    accentColor: "#1db954"
  },
  {
    name: "Meta",
    logo: "👥",
    primaryColor: "#1877f2",
    secondaryColor: "#42a5f5",
    gradient: "linear-gradient(135deg, #1877f2 0%, #42a5f5 100%)",
    textColor: "#ffffff",
    accentColor: "#00d4ff"
  },
  {
    name: "TikTok",
    logo: "🎭",
    primaryColor: "#ff0050",
    secondaryColor: "#00f2ea",
    gradient: "linear-gradient(135deg, #ff0050 0%, #00f2ea 100%)",
    textColor: "#ffffff",
    accentColor: "#ff0050"
  },
  {
    name: "Uber",
    logo: "🚗",
    primaryColor: "#000000",
    secondaryColor: "#276ef1",
    gradient: "linear-gradient(135deg, #000000 0%, #276ef1 100%)",
    textColor: "#ffffff",
    accentColor: "#276ef1"
  },
  {
    name: "Airbnb",
    logo: "🏠",
    primaryColor: "#ff5a5f",
    secondaryColor: "#00a699",
    gradient: "linear-gradient(135deg, #ff5a5f 0%, #00a699 100%)",
    textColor: "#ffffff",
    accentColor: "#ff5a5f"
  },
  {
    name: "Discord",
    logo: "💬",
    primaryColor: "#5865f2",
    secondaryColor: "#7289da",
    gradient: "linear-gradient(135deg, #5865f2 0%, #7289da 100%)",
    textColor: "#ffffff",
    accentColor: "#00d4ff"
  }
];

export function getRandomCompanyTheme(): CompanyTheme {
  return companyThemes[Math.floor(Math.random() * companyThemes.length)];
}

export function getCompanyThemeByName(name: string): CompanyTheme | undefined {
  return companyThemes.find(theme => theme.name.toLowerCase() === name.toLowerCase());
}
